import React from 'react';
import PropTypes from 'prop-types';

import { Chip, Tab, Tabs } from '@/mui/components';

import styles from './Chips.module.scss';

function ChipsSkeleton({ className = '' }) {
  const countOfChips = Math.ceil((window.innerWidth * 0.7) / 100);

  return (
    <div className={className}>
      <Tabs
        size="small"
        variant="scrollable"
        value=""
        allowScrollButtonsMobile
        classes={{
          root: styles.TabsRoot,
          indicator: styles.TabsIndicator,
        }}
      >
        <Tab
          label={
            <Chip
              label="All"
              size="small"
              color="neutral"
              variant="filled"
              className={styles.Chip}
              classes={{
                label: styles.ChipLabel___plug,
              }}
              onClick={() => null}
            />
          }
          value=""
          disableRipple
          className={styles.Tab}
        />
        {new Array(countOfChips).fill(null).map((_, index) => {
          const key = `key-${index}`;

          return (
            <Tab
              key={key}
              label={
                <Chip
                  label="------------------------"
                  size="small"
                  color="neutral"
                  variant="filled"
                  className={styles.Chip}
                  classes={{
                    label: styles.ChipLabel___plug,
                  }}
                  onClick={() => null}
                />
              }
              value={key}
              disableRipple
              className={styles.Tab}
            />
          );
        })}
      </Tabs>
    </div>
  );
}

ChipsSkeleton.propTypes = {
  className: PropTypes.string,
};

export default ChipsSkeleton;
